import { studentRequests } from "api/studentApi";
import { FileField, FileInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { Button, required } from "react-admin";
import { Box, Typography } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import Add from "@mui/icons-material/Add";

const AddPreviousEducationDocumentsModal = ({ studentId, id }) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const handleSubmit = async formData => {
    await dataProvider.customRequest(
      studentRequests.createStudentPreviousEducationDiplomaDocuments({ studentId, previousStudentEducationId: id }),
      { File: formData.file },
      "POST",
      null,
      true,
    );
    refresh();
    notify("Успешна прикачен документ", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Добавяне на документ за предходно образование"
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Добавяне на документ"
          variant="contained"
          startIcon={<Add />}
        />
      }
    >
      <FileImport />
    </FormModal>
  );
};

export default AddPreviousEducationDocumentsModal;

const FileImport = () => {
  return (
    <FileInput
      placeholder={
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, py: 0.5 }}>
          <UploadFileIcon color="primary" />
          <Typography>Добавете файл</Typography>
        </Box>
      }
      label="Документ"
      source="file"
      validate={required()}
    >
      <FileField
        source="title"
        title="title"
      />
    </FileInput>
  );
};
